import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';




const ProratedReadingBar = ({ startPosition, endPosition, incConsumption, excConsumption, prorationPosition }) => {
    const incWidth = prorationPosition - startPosition;
    const excWidth = endPosition - prorationPosition;
    const width = endPosition - startPosition;
    const ratio1 = (100 * incWidth) / width;
    const ratio2 = 100 - ratio1;

    return (



        <Box
            sx={{
                left: `${startPosition}px`,
                width: `${width}px`,
            }}

        >
            <Stack direction="row" sx={{
                position: 'relative',
                gap: 0,
                alignItems: 'center',
            }} >

                <Chip
                    sx={{
                        width: `${ratio1}%`,
                        backgroundColor: '#66bb6a',
                        display: 'flex',
                        alignItems: 'center',
                        color: 'white',
                        px: 1,
                    }}
                    label={
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                px: 1,
                            }}
                        >
                            <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                                {incConsumption.toFixed(3)} kWh / {incConsumption + excConsumption} kWh
                            </Typography>
                        </Box>
                    }
                />

                <Chip
                    sx={{
                        width: `${ratio2}%`,
                        backgroundColor: '#66bb6a', // Arka plan rengi
                        backgroundImage: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
                        backgroundSize: '10px 10px', // Çizgilerin boyutu
                        display: 'flex',
                        alignItems: 'center',
                        color: 'white',
                        px: 1,
                    }}
                    label={
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                                px: 1,
                            }}
                        >
                            <Typography variant="body2" sx={{ color: 'white', fontSize: '0.8rem' }}>
                                {excConsumption.toFixed(3)} kWh
                            </Typography>
                        </Box>
                    }
                />
            </Stack>
        </Box>
    )


};

export default ProratedReadingBar;
